import signService from "@/services/sign/services/sign.service";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  SignCreateSignDtoGen,
  SignDigitalSignatureRequestSignerViewModelGen,
  SignDigitalSignatureRequestViewModelGen
} from "../../services/sign/v1/data-contracts";

@Module({
  dynamic: true,
  namespaced: true,
  name: "sign-create",
  store
})
export class SignCreateStore extends VuexModule {
  private _request: SignDigitalSignatureRequestSignerViewModelGen = {} as any;
  private _signature: SignDigitalSignatureRequestViewModelGen = {} as any;

  get request() {
    return this._request;
  }

  get signature() {
    return this._signature;
  }

  @Mutation
  mutateRequest(request: SignDigitalSignatureRequestSignerViewModelGen) {
    this._request = request;
  }

  @Mutation
  mutateSignature(signature: SignDigitalSignatureRequestViewModelGen) {
    this._signature = signature;
  }

  @Action
  async create(data: { partnerId: string; requestId: string; data: SignCreateSignDtoGen }) {
    const res = await signService.create(data.partnerId, data.requestId, data.data);

    this.context.commit("mutateRequest", res);

    return res;
  }

  @Action
  async find(requestId: string) {
    const res = await signService.find(requestId);

    this.context.commit("mutateRequest", res);

    return res;
  }
}

export const SignCreateModule = getModule(SignCreateStore);
